/*
 -  Main scripts
 */

import $ from 'jquery'; // Import jQuery lib
import 'bootstrap/js/dist/util';  // Import bootstrap plugins
import 'bootstrap/js/dist/carousel';


// Document ready
$(function() {
	var $window = $( window ),
			$nav = $( 'nav' ),
			navHeight = $nav.outerHeight(),
			navDefOffset = $nav.offset().top,
			lastPosition = $window.scrollTop();

	$('.carousel--press-and-news').carousel({
		interval: false
	});

	$('.carousel--technology-and-enviroment').carousel({
		interval: false
	});

	sameHeight($( '.carousel--press-and-news .carousel-item' ));
	sameHeight($( '.carousel--technology-and-enviroment .carousel-item' ));

	$window.on('resize', function(){
		// reset
		$( '.carousel--press-and-news .carousel-item, .carousel--technology-and-enviroment .carousel-item').attr('style', '');

		sameHeight($( '.carousel--press-and-news .carousel-item' ));
		sameHeight($( '.carousel--technology-and-enviroment .carousel-item' ));

		navInit( $nav.outerHeight() );
	});

	$( '.footer-year' ).text( new Date().getFullYear() );

	$window.on('scroll', function() {
		var scrollPosition = $window.scrollTop();

		navInit(navHeight);

		if ( scrollPosition > navDefOffset + navHeight ) {
			$nav.addClass( 'nav--fixed' );
		} else {
			$nav.removeClass( 'nav--fixed' );
		}
	});

	$('.main-nav a' ).on('click', function(e) {
		var _this = $( this );

		if (this.hash !== "") {
			e.preventDefault();

			var
				hash = this.hash,
				manualOffsetValue = _this.data('scroll-offset');

			scrollTo(hash, manualOffsetValue, function(){
				history.pushState(null, null, hash);
				_this.blur();
			});
		}
	});

	$( '.main-nav a, .nav-toggle' ).on('click', function(e) {
		$header.toggleClass( classToggle );
	});

	function navInit(navHeight) {
		$nav.height( navHeight );
	}

	function sameHeight($el) {
		var selector = $el;
		var heights = [];

		selector.each(function(){
				var height = $(this).height();
				heights.push(height);
		});

		var maxHeight = Math.max.apply(null, heights);

		selector.each(function(){
				$(this).height(maxHeight);
		});
	}


	function scrollTo(target, offset, callback) {
		var
			target = target ? target : '',
			offset = offset ? offset : 0,
			callback = callback ? callback : null;

		$('html, body').animate({
			scrollTop: $(target).offset().top + offset
		}, 800, function(){
			callback();
		});
	}
});